import React from "react";
import PropTypes from "prop-types";
import { Dropdown } from "primereact/dropdown";
import ReactCountryFlag from "react-country-flag";
import { getData } from "country-list";

const countries = getData()
  .map((country) => ({
    name: country.name,
    code: country.code,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));
const CountryDropdown = (props) => {
  const selectedCountry =
    typeof props.value === "string"
      ? countries.find((country) => country.code === props.value)
      : props.value;

  const appendTarget = props.appendTo ?? document.body;

  return (
    <>
      <Dropdown
        {...props}
        value={selectedCountry}
        onChange={props.onChange}
        options={countries}
        optionLabel="name"
        placeholder="Select a Country"
        className={`w-full ${props.className}  ${props.error ? "p-invalid" : ""}`}
        appendTo={appendTarget}
        itemTemplate={(option) => (
          <div className="flex align-items-center">
            <ReactCountryFlag
              countryCode={option.code}
              svg
              className="flag-svg-icon"
            />
            <span>{option.name}</span>
          </div>
        )}
        disabled={props.disabled}
      />
    </>
  );
};

CountryDropdown.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.object,
};

export default CountryDropdown;
